import en_US from './en-US';

export default { 'en-US': en_US };
